import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useCallback } from 'react';
import { breakdownString } from './index.service';
import DefaultTheme from './theme';
export var ItemTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { OptionType } from '../../select';
import type { ItemThemeType } from './theme';

type Props = {|
  option: OptionType,
  selected: boolean,
  active: boolean,
  lookupText?: ?string,
  checkbox: boolean,
  onSelect: (option: OptionType) => any,
  onMouseEnter?: * => any,
  theme?: ItemThemeType,
  rest?: any,
|}
// these props are to tell component user who wants to design conpletely
// custom Item component, what this custom component needs to have in props
export type ItemProps = {|
  ...Props,
  theme?: any,
|};
*/

var Item = function Item(_ref
/*: Props */
) {
  var option = _ref.option,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      lookupText = _ref.lookupText,
      _ref$checkbox = _ref.checkbox,
      checkbox = _ref$checkbox === void 0 ? false : _ref$checkbox,
      onSelect = _ref.onSelect,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["option", "selected", "active", "lookupText", "checkbox", "onSelect", "theme"]);

  var highlightText = useCallback(function (text, highlight) {
    var slices = breakdownString(text, highlight || '');
    return slices.map(function (slice, idx) {
      return slice.match ? /*#__PURE__*/React.createElement(theme.Highlight, {
        // eslint-disable-next-line
        key: idx,
        "data-test": "select-list-item-highlight"
      }, slice.value) : slice.value;
    });
  }, [breakdownString]);
  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    highlight: active || !checkbox && selected,
    onClick: function onClick(e) {
      e.preventDefault();
      onSelect(option);
    },
    "data-test": "select-list-item-main"
  }, rest), checkbox ? /*#__PURE__*/React.createElement(theme.CheckBox, {
    checked: selected,
    "data-test": "select-list-item-checkboxicon"
  }) : null, /*#__PURE__*/React.createElement(theme.Label, {
    "data-test": "select-list-item-label"
  }, highlightText(option.label, lookupText)));
};

export default Item;